"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationsFromWorker = exports.cancelWorkerInstance = exports.releaseWorkerInstance = exports.spawnWorkerInstance = exports.currentEnv = void 0;
const constants_1 = require("../constants");
exports.currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const DEFAULT_NOTIFICATION_WORKER_TIMEOUT_MS = 15000;
const COOKIE_NAME_LOGGED = "seth-session-logged";
const COOKIE_NAME_SOFT_LOGGED = "seth-session-softlogged";
let activeWorkerInstance = null;
const workerHandleByInstance = new WeakMap();
function getCookie(cname) {
    if (typeof document === "undefined") {
        return "";
    }
    const name = cname + "=";
    let decodedCookie = "";
    try {
        decodedCookie = decodeURIComponent(document.cookie || "");
    }
    catch (error) {
        decodedCookie = document.cookie || "";
    }
    const cookies = decodedCookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}
function getWorkerSessionMode() {
    const isLogged = Boolean(getCookie(COOKIE_NAME_LOGGED));
    const isSoftLogged = Boolean(getCookie(COOKIE_NAME_SOFT_LOGGED));
    if (exports.currentEnv === "local") {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (isLogged) {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (isSoftLogged) {
        return constants_1.LOGGED_STATUS.SOFTLOGGED;
    }
    return constants_1.LOGGED_STATUS.PUBLIC;
}
function isCommercialOnlyRequest(notificationTypes = []) {
    return (Array.isArray(notificationTypes) &&
        notificationTypes.length > 0 &&
        notificationTypes.every((type) => type === constants_1.NOTIFICATION_TYPES.COMMERTIAL));
}
function createMissingSethSessionError() {
    const error = new Error("notification_worker_missing_seth_session");
    error.code = "NOTIFICATION_WORKER_MISSING_SETH_SESSION";
    return error;
}
function getNotisWorkerPath() {
    switch (exports.currentEnv) {
        case "qa_ssr":
        case "dev_ssr": {
            return constants_1.WORKER_URLS.QA;
        }
        default:
            return constants_1.WORKER_URLS.PROD;
    }
}
function serializeError(error) {
    if (!error) {
        return "unknown_error";
    }
    return (error === null || error === void 0 ? void 0 : error.message) || `${error}`;
}
function getWorkerCandidates() {
    var _a;
    const workerPath = getNotisWorkerPath();
    const candidates = [workerPath, "/sw/workers/notification.worker.worker.js"];
    if (typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin)) {
        candidates.push(`${window.location.origin}/sw/workers/notification.worker.worker.js`);
    }
    return [...new Set(candidates.filter(Boolean))];
}
function spawnWorkerInstance() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (activeWorkerInstance) {
            return activeWorkerInstance;
        }
        if (typeof window === "undefined" || typeof Worker === "undefined") {
            return null;
        }
        try {
            const Comlink = yield Promise.resolve().then(() => __importStar(require("comlink")));
            const candidates = getWorkerCandidates();
            for (const workerPath of candidates) {
                try {
                    const worker = new Worker(workerPath);
                    const WorkerInstance = Comlink.wrap(worker);
                    workerHandleByInstance.set(WorkerInstance, {
                        worker,
                        workerPath,
                        releaseProxy: () => { var _a; return (_a = WorkerInstance === null || WorkerInstance === void 0 ? void 0 : WorkerInstance[Comlink.releaseProxy]) === null || _a === void 0 ? void 0 : _a.call(WorkerInstance); },
                    });
                    (_a = worker === null || worker === void 0 ? void 0 : worker.addEventListener) === null || _a === void 0 ? void 0 : _a.call(worker, "error", (event) => {
                        console.log("[notifications-worker] runtime_error", {
                            workerPath,
                            error: serializeError((event === null || event === void 0 ? void 0 : event.error) || event),
                        });
                        releaseWorkerInstance(WorkerInstance, "runtime_error");
                    });
                    activeWorkerInstance = WorkerInstance;
                    return activeWorkerInstance;
                }
                catch (error) {
                    console.log("[notifications-worker] spawn_failed", {
                        workerPath,
                        error: serializeError(error),
                    });
                }
            }
            console.log("[notifications-worker] bootstrap_failed", {
                currentEnv: exports.currentEnv,
                candidates,
            });
        }
        catch (e) {
            console.log("[notifications-worker] bootstrap_failed", {
                currentEnv: exports.currentEnv,
                error: serializeError(e),
            });
        }
        return null;
    });
}
exports.spawnWorkerInstance = spawnWorkerInstance;
function releaseWorkerInstance(workerInstance = activeWorkerInstance, reason = "manual") {
    var _a, _b, _c;
    if (!workerInstance) {
        return null;
    }
    const handle = workerHandleByInstance.get(workerInstance);
    try {
        (_a = handle === null || handle === void 0 ? void 0 : handle.releaseProxy) === null || _a === void 0 ? void 0 : _a.call(handle);
    }
    catch (error) {
        console.log("[notifications-worker] release_proxy_failed", {
            reason,
            workerPath: handle === null || handle === void 0 ? void 0 : handle.workerPath,
            error: serializeError(error),
        });
    }
    try {
        (_c = (_b = handle === null || handle === void 0 ? void 0 : handle.worker) === null || _b === void 0 ? void 0 : _b.terminate) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    catch (error) {
        console.log("[notifications-worker] terminate_failed", {
            reason,
            workerPath: handle === null || handle === void 0 ? void 0 : handle.workerPath,
            error: serializeError(error),
        });
    }
    workerHandleByInstance.delete(workerInstance);
    if (workerInstance === activeWorkerInstance) {
        activeWorkerInstance = null;
    }
    return null;
}
exports.releaseWorkerInstance = releaseWorkerInstance;
function cancelWorkerInstance(workerInstance, reason) {
    return __awaiter(this, void 0, void 0, function* () {
        return releaseWorkerInstance(workerInstance, reason);
    });
}
exports.cancelWorkerInstance = cancelWorkerInstance;
function getNotificationsFromWorker({ worker, params, notificationTypes, timeoutMs = DEFAULT_NOTIFICATION_WORKER_TIMEOUT_MS, }) {
    return __awaiter(this, void 0, void 0, function* () {
        let timeoutId = null;
        const sessionMode = getWorkerSessionMode();
        const isLoggedSession = sessionMode === constants_1.LOGGED_STATUS.LOGGED;
        const isAllowedCommercialOnlyRequest = (sessionMode === constants_1.LOGGED_STATUS.COMMERCIAL_ONLY ||
            sessionMode === constants_1.LOGGED_STATUS.SOFTLOGGED) &&
            isCommercialOnlyRequest(notificationTypes);
        if (!isLoggedSession && !isAllowedCommercialOnlyRequest) {
            releaseWorkerInstance(worker, "missing_seth_session");
            throw createMissingSethSessionError();
        }
        const workerParams = Object.assign(Object.assign({}, params), { notificationSessionMode: (params === null || params === void 0 ? void 0 : params.notificationSessionMode) || sessionMode });
        try {
            return yield Promise.race([
                worker.getNotifications(workerParams, notificationTypes),
                new Promise((_, reject) => {
                    timeoutId = setTimeout(() => {
                        const error = new Error("notification_worker_timeout");
                        error.code = "NOTIFICATION_WORKER_TIMEOUT";
                        reject(error);
                    }, timeoutMs);
                }),
            ]);
        }
        catch (error) {
            if ((error === null || error === void 0 ? void 0 : error.code) === "NOTIFICATION_WORKER_TIMEOUT") {
                releaseWorkerInstance(worker, "timeout");
            }
            throw error;
        }
        finally {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        }
    });
}
exports.getNotificationsFromWorker = getNotificationsFromWorker;
//# sourceMappingURL=workers.js.map